// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"Scenarios_thecomp__e7NTD"};